import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ProductsContainer from '@/components/AutocompletePopup/Products/ProductsContainer.vue'

import {inject, onMounted} from "vue";
import {storeToRefs} from "pinia";
import {usePopularProductsStore} from "@/store/AutocompletePopup/PopularProductsStore";
import {SmartSearchTranslationsInterface} from "@/core/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'PopularProductsContainer',
  setup(__props) {

const popularProductStore = usePopularProductsStore()

const SmartSearchConfig = inject('SmartSearchConfig').value;

const popularQueriesEnabled = SmartSearchConfig.onfocus.popularQueries.enabled
const {enabled, sections} = SmartSearchConfig.onfocus.predefinedQueries
const showPredefinedQueries = sections.length > 0 && enabled
const popularProductsEnabled = SmartSearchConfig.onfocus.popularProducts.enabled
const topProductEnabled = SmartSearchConfig.onfocus.topProduct.enabled
const recentQueriesEnabled = SmartSearchConfig.onfocus.recentQueries.enabled

const showQueriesSection = popularQueriesEnabled || showPredefinedQueries || recentQueriesEnabled

const {getTopProduct, getPopularProducts, getPopularProductsWithoutFirst} = storeToRefs(popularProductStore)
const popularProducts = topProductEnabled ? getPopularProductsWithoutFirst : getPopularProducts
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

onMounted(async () => {
  await popularProductStore.fetchPopularProducts()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'q-col-12 q-col-lg-9 q-pt-1': _unref(showQueriesSection), 'q-col-12 q-pt-1': !_unref(showQueriesSection)}, "on-focus__popular-products q-pt-1"])
  }, [
    _createVNode(ProductsContainer, {
      sectionEnabled: _unref(popularProductsEnabled),
      promotedProductEnabled: _unref(topProductEnabled),
      promotedProductHeader:  _unref(SmartSearchTranslations).popularProducts.topProductHeader,
      promotedProduct: _unref(getTopProduct),
      productsHeader: _unref(SmartSearchTranslations).popularProducts.header,
      productsList: _unref(popularProducts),
      canShowPromotedSection: _unref(topProductEnabled)
    }, null, 8, ["sectionEnabled", "promotedProductEnabled", "promotedProductHeader", "promotedProduct", "productsHeader", "productsList", "canShowPromotedSection"])
  ], 2))
}
}

})